import React from 'react';
import { Tag, Mail, Gift, Users } from 'lucide-react';

const campaigns = [
  {
    id: 1,
    name: 'Summer Sale 2025',
    type: 'Discount',
    status: 'Active',
    startDate: '2025-06-01',
    endDate: '2025-06-30',
    performance: '32% conversion',
  },
  {
    id: 2,
    name: 'New Customer Welcome',
    type: 'Email',
    status: 'Active',
    startDate: '2025-01-01',
    endDate: 'Ongoing',
    performance: '45% open rate',
  },
  {
    id: 3,
    name: 'Referral Program',
    type: 'Reward',
    status: 'Active',
    startDate: '2025-03-15',
    endDate: 'Ongoing',
    performance: '128 referrals',
  },
];

export default function Marketing() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Marketing Campaigns</h2>

      {/* Marketing Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-lg">
              <Tag className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Active Campaigns</p>
              <p className="text-2xl font-bold">8</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <Mail className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Email Subscribers</p>
              <p className="text-2xl font-bold">2.5K</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <Gift className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Promo Codes Used</p>
              <p className="text-2xl font-bold">456</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center gap-4">
            <div className="bg-orange-100 p-3 rounded-lg">
              <Users className="h-6 w-6 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Referral Signups</p>
              <p className="text-2xl font-bold">128</p>
            </div>
          </div>
        </div>
      </div>

      {/* Campaigns Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="text-lg font-semibold">Active Campaigns</h3>
          <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors">
            New Campaign
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="text-left py-3 px-4">Campaign Name</th>
                <th className="text-left py-3 px-4">Type</th>
                <th className="text-left py-3 px-4">Status</th>
                <th className="text-left py-3 px-4">Start Date</th>
                <th className="text-left py-3 px-4">End Date</th>
                <th className="text-left py-3 px-4">Performance</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((campaign) => (
                <tr key={campaign.id} className="border-t border-gray-200">
                  <td className="py-3 px-4 font-medium">{campaign.name}</td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 rounded-full text-sm ${
                      campaign.type === 'Discount'
                        ? 'bg-green-100 text-green-700'
                        : campaign.type === 'Email'
                        ? 'bg-blue-100 text-blue-700'
                        : 'bg-purple-100 text-purple-700'
                    }`}>
                      {campaign.type}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-sm">
                      {campaign.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">{campaign.startDate}</td>
                  <td className="py-3 px-4">{campaign.endDate}</td>
                  <td className="py-3 px-4">{campaign.performance}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}